<div fxLayout="column" fxflex="100%">
    <div fxLayout="column" fxGrow="false">
        <div class="dhl-header-container-v2">
            <h1 *ngIf="templateData" class="m-Opener-headline contact-header">
                {{templateData.header.title.maintitle}}
            </h1>
        </div>   
    </div>
 </div>
<div *ngIf="templateData" class="row contactus-container">
    <div class="col-xl-6">
        <div class="content-style">
            <div class="content-heading-style">{{templateData.header.contactUsMessage.contentHeading}}</div>
            <div class="content-text-style">{{templateData.header.contactUsMessage.contentPhone}}
                <span class="contact-info-text-style">{{templateData.header.contactUsMessage.phoneNumber}}</span>
            </div>
            <div class="content-text-style">{{templateData.header.contactUsMessage.contentEmail}}
                <span> <a href="" class="contact-info-text-style">{{templateData.header.contactUsMessage.emailId}}</a></span>
            </div>
        </div>
    </div>
</div>